import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSuppressOllieFab } from 'src/components/ollie/OllieAssistantContext'
import {
  DatePicker,
  Divider,
  List,
  Input,
  Select,
  Popconfirm,
  Tooltip,
  Collapse,
  Modal,
  message,
} from 'antd'
import styled from 'styled-components/macro'
import {
  DeleteOutlined,
  LoadingOutlined,
  LockOutlined,
  RedoOutlined,
  UnlockOutlined,
} from '@ant-design/icons'
import dayjs from 'dayjs'
import ShareWithGroupButton from 'src/screens/menu-builder/components/ShareWithGroupButton'
import {
  StockHeroBand,
  StockHeroIntro,
  StockHeaderRow,
  StockPageTitle,
  StockPrimaryButton,
  StockQuietButton,
} from 'src/components/stock/StockPageChrome'
import { Link, useHistory, useLocation } from 'react-router-dom'
import {
  createStock,
  deleteStockTake,
  fetchStockTakes,
  updateStockTake,
} from '../../features/StockSlice'
import { useDispatch, useSelector } from 'react-redux'
import Loading from '../../components/styled/Loading'
import moment from 'moment'
// Onboarding video (Stock Management Made Simple) disabled — may re-enable with an updated walkthrough later.
// import { Banner } from '../menu-builder/RecipeDashboard'
// import demoVideo from '../../assets/vidoes/Stock.mp4'
import { API } from 'src/utils/interceptor'
import { formatGbp } from 'src/utils/formatGbp'
import useStockRoleCapabilities from 'src/hooks/useStockRoleCapabilities'
import { editVenue } from 'src/features/VenueSlice'
import StockSettingsPanel from './StockSettingsPanel'
import ManageGroupsModal from './partials/ManageGroupsModal'
import LinkProductsModal from './linked/LinkProductsModal'
import useGrowthEngineFeatureGuidance from 'src/hooks/useGrowthEngineFeatureGuidance'
import useGrowthEngineSuggestedData from 'src/hooks/useGrowthEngineSuggestedData'
import GrowthEngineFeatureEmptyState from 'src/components/growthEngine/GrowthEngineFeatureEmptyState'
import GrowthEngineProgressAskOllie from 'src/components/growthEngine/GrowthEngineProgressAskOllie'
import { bindGuidedEmptySuggestedActions } from 'src/utils/growthEngineSuggestedData'
import { parseGrowthEngineSuggestedProduct } from 'src/utils/growthEngineSuggestedProduct'
import { resolveProgressAskOllie } from 'src/utils/growthEngineProgressAskOllie'
import StockTakesAboveFoldLayout from 'src/components/growthEngine/StockTakesAboveFoldLayout'
import {
  defaultStockTakeCreatePeriod,
  shouldLiftStockTakesEmptyAboveFold,
  shouldShowStockTakesGuidedEmpty,
} from 'src/utils/growthEngineRecommendation'
import { wasStockTakeUnlocked } from 'src/utils/stockTakeLockState'
import {
  STOCK_LIST_EXPECTED_PLACEHOLDER,
  STOCK_LIST_NOT_COUNTED_YET,
  stockLinesWereCounted,
  stockListExpectedText,
  stockListStockText,
} from 'src/utils/stockOnHand'
import { buildReviewBeforeLockStats } from 'src/utils/stockTakeLockConfirm'
import { getStockTakesListEmptyCopy } from 'src/utils/growthEngineStockHonestFirstTry'
import {
  filterEmptySupplierCloneTakes,
  formatPartialCardLine,
  formatStockTakeDateRange,
  formatStockTakeListSupplierLine,
  formatStockTakeOverlapCue,
  getPartialCardMeta,
  getStockTakeListHeading,
  getStockTakePageHeading,
  partialCardTooltip,
} from 'src/utils/stockTakePartialCard'
import {
  STOCK_TAKE_HISTORY_DATE_PLACEHOLDER,
  STOCK_TAKE_HISTORY_SEARCH_PLACEHOLDER,
  STOCK_TAKE_HISTORY_SUPPLIER_PLACEHOLDER,
  countHiddenSupplierTakes,
  filterStockTakeHistory,
  listStockTakeHistorySupplierOptions,
  readStockTakeHistoryCountTypeFilter,
  revealCreatedTakeInHistory,
  shouldShowPartialGroupCombobox,
  shouldShowPartialGroupFilterHelper,
  stockTakeHiddenSupplierCountsLine,
  writeStockTakeHistoryCountTypeFilter,
} from 'src/utils/stockTakeHistoryFilters'
import {
  STOCK_TAKE_ANALYTICS_EVENTS,
  beginStockTakeHistorySearchUsed,
  trackStockTakeAnalytics,
} from 'src/utils/stockTakeAnalytics'
import {
  OLLIE_FAB_CONTENT_CLEARANCE,
  OLLIE_FAB_INLINE_CLEARANCE,
} from 'src/components/ollie/ollieFabPlacement'
import { WASTAGE_COPY, wastageLondonToday } from 'src/constants/wastage'
import WasteHomeCard from 'src/components/stock/WasteHomeCard'
import {
  buildStockTakeCreatePayload,
  canRepeatStockTake,
  canSubmitStockTakeCreate,
  isStockTakeCreateDatesDisabled,
  isStockTakeCreateSuppliersDisabled,
  STOCK_TAKE_CREATE_CTA_HINT,
  STOCK_TAKE_CREATE_DATES_LABEL,
  STOCK_TAKE_CREATE_HOUSE_BODY,
  STOCK_TAKE_CREATE_HOUSE_HEADING,
  STOCK_TAKE_CREATE_SUPPLIER_BODY,
  STOCK_TAKE_CREATE_SUPPLIER_HEADING,
  STOCK_TAKE_CREATE_SUPPLIERS_LABEL,
  STOCK_TAKE_CREATE_SUPPLIERS_PLACEHOLDER,
  STOCK_TAKE_CREATE_WHY_DATES,
  STOCK_TAKE_CREATE_WHY_SUPPLIERS,
  STOCK_TAKE_GROUPS_WHY_LINE,
  STOCK_TAKE_JOB_HOUSE,
  STOCK_TAKE_JOB_SUPPLIER,
  STOCK_TAKE_LIST_OPEN_LABEL,
  stockTakeListReportDisabledCopy,
  STOCK_TAKE_LIST_SUBTITLE,
  STOCK_TAKE_QUIET_DRAWER_TITLE,
  keepStockTakeSuppliersOnVenue,
  listStockTakeCreateSupplierOptions,
  pickLatestRepeatableStockTake,
  pickOpenRepeatableStockTake,
  prefillStockTakeCreateFromLastSupplier,
  shouldShowCountAgainHero,
  shouldSkipLastSupplierCreatePrefill,
  resolveStockTakeRepeatAction,
  stockTakeOpenTodayLabel,
  stockTakeRepeatAgainLabel,
  supplierTitlesForCreateIds,
  uniqueStockTakeSupplierIds,
} from 'src/utils/stockTakeCreateForm'
import { canUseStockTakeReports } from 'src/utils/stockTakePlanGate'

const { RangePicker } = DatePicker
const { Panel } = Collapse

const StockList = ({ ollieRow = null, accessChrome = null }) => {
  const venueId = useSelector(state => state.venue?.venue?._id)
  const venueTitle = useSelector(state => state.venue?.venue?.title)
  const venue = useSelector(state => state.venue?.venue)
  const currentPlan = venue?.usageLimits?.currentPlan || 'Free'
  const account = useSelector(state => state.auth?.account)
  const history = useHistory()
  const location = useLocation()
  const progressHandoff = parseGrowthEngineSuggestedProduct(location.search)
  const dispatch = useDispatch()
  const { canViewExpectedAndVariance, canUnlockStockTake } =
    useStockRoleCapabilities()
  const stocks = useSelector(state => state.stockTakes.stockTakes)
  const isLoading = useSelector(state => state.stockTakes.isLoading)
  const [linesCountedById, setLinesCountedById] = useState({})
  const buttonLoading = useSelector(state => state.stockTakes.buttonLoading)
  const venueSuppliers = useSelector(
    state => state.venueSuppliers?.venueSuppliers,
  )
  const suppliersLoading = useSelector(state => state.venueSuppliers?.isLoading)
  const createSupplierOptions = useMemo(
    () => listStockTakeCreateSupplierOptions(venueSuppliers),
    [venueSuppliers],
  )
  const lastSuppliersHydratedVenue = useRef('')
  const skippedPrefillForMainRef = useRef(false)
  const [dateOfCreation, setDateOfCreation] = useState([])
  const [stockTakeName, setStockTakeName] = useState('')
  const [createSupplierIds, setCreateSupplierIds] = useState([])
  const [isCreating, setIsCreating] = useState(false)
  const creatingRef = useRef(false)
  const createFormRef = useRef(null)
  const [visibleCalendar, setVisibleCalendar] = useState(false)
  const refToSelectDate = useRef()
  const [countTypeFilter, setCountTypeFilter] = useState('ALL')
  const [partialGroupFilter, setPartialGroupFilter] = useState('ALL')
  const [historySearch, setHistorySearch] = useState('')
  const [historySupplierIds, setHistorySupplierIds] = useState([])
  const [historyDateRange, setHistoryDateRange] = useState(null)
  const historySearchTrackedRef = useRef(false)

  useEffect(() => {
    const next = beginStockTakeHistorySearchUsed(
      historySearchTrackedRef.current,
      historySearch,
    )
    historySearchTrackedRef.current = next.tracked
    if (!next.fire) return
    trackStockTakeAnalytics(venueId, {
      eventName: STOCK_TAKE_ANALYTICS_EVENTS.HISTORY_SEARCH_USED,
      platform: 'dashboard',
      metadata: { queryLength: next.queryLength },
    })
  }, [historySearch, venueId])

  const applyCountTypeFilter = nextFilter => {
    const saved = writeStockTakeHistoryCountTypeFilter(venueId, nextFilter)
    setCountTypeFilter(saved)
    if (saved !== 'PARTIAL') setPartialGroupFilter('ALL')
    return saved
  }
  const [countMetadata, setCountMetadata] = useState({
    siteName: '',
    siteManager: '',
    lineManager: '',
    countedByName: '',
    countNotes: '',
  })
  const [countMetadataSaved, setCountMetadataSaved] = useState(false)
  const [partialGroups, setPartialGroups] = useState([])
  const [shareSheetId, setShareSheetId] = useState(null)
  const [manageGroupsVisible, setManageGroupsVisible] = useState(false)
  useSuppressOllieFab({ groupsOpen: manageGroupsVisible })
  const [linkProductsVisible, setLinkProductsVisible] = useState(false)
  const [linkableProducts, setLinkableProducts] = useState([])
  const [linkedGroups, setLinkedGroups] = useState([])
  const [partialGroupProducts, setPartialGroupProducts] = useState([])
  const guidedSuccess = useGrowthEngineFeatureGuidance({
    venueId,
    surface: 'stock_takes',
    featureId: 'stock_takes',
  })
  const showStockTakesGuidedEmpty = shouldShowStockTakesGuidedEmpty({
    stockTakes: stocks,
    guidedSuccess,
    loading: isLoading,
  })
  const liftStockTakesEmpty = shouldLiftStockTakesEmptyAboveFold({
    stockTakes: stocks,
    guidedSuccess,
    loading: isLoading,
  })
  const suggested = useGrowthEngineSuggestedData({
    venueId,
    featureId: 'stock_takes',
    items: guidedSuccess?.suggestedData?.items,
  })

  useEffect(() => {
    dispatch(fetchStockTakes(venueId))
  }, [dispatch, venueId])

  useEffect(() => {
    if (!venueId || suppliersLoading || isLoading) return
    const venueSupplierIds = createSupplierOptions.map(option => option.value)
    if (shouldSkipLastSupplierCreatePrefill(countTypeFilter)) {
      skippedPrefillForMainRef.current = true
      setCreateSupplierIds([])
      return
    }
    if (
      lastSuppliersHydratedVenue.current === venueId &&
      !skippedPrefillForMainRef.current
    ) {
      setCreateSupplierIds(current =>
        keepStockTakeSuppliersOnVenue(current, venueSupplierIds),
      )
      return
    }
    lastSuppliersHydratedVenue.current = venueId
    skippedPrefillForMainRef.current = false
    const prefill = prefillStockTakeCreateFromLastSupplier(stocks, {
      venueSupplierIds,
      historyCountType: countTypeFilter,
    })
    setCreateSupplierIds(prefill.supplierIds)
    if (prefill.name) setStockTakeName(prefill.name)
  }, [
    venueId,
    suppliersLoading,
    isLoading,
    createSupplierOptions,
    stocks,
    countTypeFilter,
  ])

  useEffect(
    () => () => {
      setCreateSupplierIds([])
    },
    [],
  )

  useEffect(() => {
    if (!venueId) return
    fetchPartialGroups()
  }, [venueId])

  useEffect(() => {
    if (!venueId) return
    setCountTypeFilter(readStockTakeHistoryCountTypeFilter(venueId))
  }, [venueId])

  useEffect(() => {
    setCountMetadata(prev => ({
      ...prev,
      siteName: prev.siteName || venueTitle || '',
      countedByName:
        prev.countedByName ||
        account?.name ||
        account?.emailAddress ||
        account?.username ||
        '',
    }))
  }, [venueTitle, account?.name, account?.emailAddress, account?.username])

  useEffect(() => {
    if (!venue?._id) return
    setCountMetadata(prev => ({
      ...prev,
      siteName: venueTitle || '',
      siteManager: venue?.stockTakeDefaultSiteManager || '',
      lineManager: venue?.stockTakeDefaultLineManager || '',
      countedByName:
        account?.name || account?.emailAddress || account?.username || '',
      countNotes: venue?.stockTakeDefaultCountNotes || '',
    }))
  }, [
    venue?._id,
    venue?.stockTakeDefaultSiteManager,
    venue?.stockTakeDefaultLineManager,
    venue?.stockTakeDefaultCountNotes,
    venueTitle,
    account?.name,
    account?.emailAddress,
    account?.username,
  ])

  const getReviewBeforeLockStats = async stockTake => {
    try {
      const products = await API.get(
        'api2',
        `venue/${venueId}/stocks/${stockTake._id}/products`,
      )

      return buildReviewBeforeLockStats(stockTake, products)
    } catch (error) {
      return {
        totalStockValue: Number(stockTake?.totalStockValue) || 0,
        totalWastageValue: Number(stockTake?.totalWastageValue) || 0,
        missingCounts: 0,
        topVariances: [],
      }
    }
  }

  const changeLockStatus = async stockTake => {
    const shouldLock = !stockTake.isLocked

    if (shouldLock) {
      const stats = await getReviewBeforeLockStats(stockTake)
      Modal.confirm({
        title: 'Review before lock',
        width: 620,
        okText: 'Lock stock take',
        cancelText: 'Cancel',
        content: (
          <ReviewSummary>
            <ReviewRow>
              <strong>Total stock value:</strong>
              <span>{formatGbp(stats.totalStockValue)}</span>
            </ReviewRow>
            <ReviewRow>
              <strong>Total wastage value:</strong>
              <span>{formatGbp(stats.totalWastageValue)}</span>
            </ReviewRow>
            <ReviewRow>
              <strong>Missing counts:</strong>
              <span>{stats.missingCounts}</span>
            </ReviewRow>
            <ReviewTopTitle>Top 5 variances</ReviewTopTitle>
            {stats.topVariances.length > 0 ? (
              stats.topVariances.map(item => (
                <ReviewVarianceItem key={`${item.title}-${item.variance}`}>
                  <span>{item.title}</span>
                  <strong>{item.variance.toFixed(2)}</strong>
                </ReviewVarianceItem>
              ))
            ) : (
              <ReviewMutedText>No variance data available.</ReviewMutedText>
            )}
          </ReviewSummary>
        ),
        onOk: () => {
          return Promise.resolve(
            dispatch(
              updateStockTake(
                venueId,
                {
                  ...stockTake,
                  isLocked: true,
                },
                'LOCK',
              ),
            ),
          ).then(() => {
            if (
              venue?.stockTakeAutoEmailEnabled &&
              Array.isArray(venue?.stockTakeReportEmails) &&
              venue.stockTakeReportEmails.length
            ) {
              message.success(
                `Stock take locked. Variance email queued to ${venue.stockTakeReportEmails.length} recipient(s).`,
              )
            } else {
              message.success('Stock take locked.')
            }
            return true
          })
        },
      })
      return
    }

    if (!canUnlockStockTake) {
      Modal.warning({
        title: 'Unlock not allowed',
        content: 'You do not have permission to unlock a locked stock take.',
        okText: 'OK',
      })
      return
    }

    let unlockReason = ''
    Modal.confirm({
      title: 'Unlock stock take?',
      okText: 'Unlock stock take',
      cancelText: 'Cancel',
      content: (
        <ReviewSummary>
          <ReviewMutedText>
            This stock take is currently locked. Unlocking it may affect reports
            and audit history. Please enter a reason before continuing.
          </ReviewMutedText>
          <ReviewMutedText
            data-testid='stock-unlock-wastage'
            style={{ marginTop: 8 }}
          >
            {WASTAGE_COPY.unlockWastage}
          </ReviewMutedText>
          <ReviewTopTitle style={{ marginTop: 12 }}>
            Unlock reason
          </ReviewTopTitle>
          <Input.TextArea
            rows={3}
            placeholder='Enter unlock reason'
            onChange={event => {
              unlockReason = event.target.value
            }}
          />
        </ReviewSummary>
      ),
      onOk: () => {
        const trimmedReason = String(unlockReason || '').trim()
        if (!trimmedReason) {
          return Promise.reject(
            new Error('Unlock reason is required before unlocking.'),
          )
        }
        dispatch(
          updateStockTake(
            venueId,
            {
              _id: stockTake._id,
              isLocked: false,
              unlockReason: trimmedReason,
            },
            'UNLOCK',
          ),
        )
        return Promise.resolve()
      },
    })
  }

  const handleDeleteButton = stockTake => {
    dispatch(deleteStockTake(venueId, stockTake, 'DELETE'))
  }

  const handleRepeatStockTake = stockTake => {
    if (creatingRef.current) return
    const action = resolveStockTakeRepeatAction(stockTake, stocks, {
      venueSupplierIds: createSupplierOptions.map(option => option.value),
    })
    if (!action) return
    if (action.kind === 'continue') {
      const openId = action.stockTake?._id || action.stockTake?.id
      applyCountTypeFilter(
        revealCreatedTakeInHistory({
          venueId,
          currentFilter: countTypeFilter,
          created: action.stockTake,
          supplierIds: uniqueStockTakeSupplierIds(
            action.stockTake?.supplierIds,
          ),
        }),
      )
      if (openId) history.push(`/v/${venueId}/stockTakes/${openId}`)
      return Promise.resolve(action.stockTake)
    }
    const payload = action.payload
    creatingRef.current = true
    setIsCreating(true)
    return dispatch(createStock(payload, venueId))
      .then(created => {
        applyCountTypeFilter(
          revealCreatedTakeInHistory({
            venueId,
            currentFilter: countTypeFilter,
            created,
            supplierIds: payload.supplierIds,
          }),
        )
        const createdId = created?._id || created?.id
        if (createdId) history.push(`/v/${venueId}/stockTakes/${createdId}`)
        return created
      })
      .finally(() => {
        creatingRef.current = false
        setIsCreating(false)
      })
  }

  const clearCreateDates = () => {
    setDateOfCreation([])
    setVisibleCalendar(false)
    if (refToSelectDate.current?.picker) {
      refToSelectDate.current.picker.state.value = []
      refToSelectDate.current.picker.clearHoverValue?.()
    }
  }

  const resetCreateForm = () => {
    clearCreateDates()
    setStockTakeName('')
    setCreateSupplierIds([])
  }

  const submitStockTakeCreate = extra => {
    if (creatingRef.current) return Promise.resolve(false)
    if (
      !canSubmitStockTakeCreate({
        startDate: dateOfCreation[0],
        endDate: dateOfCreation[1],
        supplierIds: createSupplierIds,
      })
    ) {
      return Promise.resolve(false)
    }
    creatingRef.current = true
    setIsCreating(true)
    const payload = buildStockTakeCreatePayload({
      startDate: dateOfCreation[0],
      endDate: dateOfCreation[1],
      name: stockTakeName,
      supplierIds: createSupplierIds,
      supplierTitles: supplierTitlesForCreateIds(
        createSupplierIds,
        createSupplierOptions,
      ),
      countMetadata,
      ...extra,
    })
    return dispatch(createStock(payload, venueId))
      .then(created => {
        resetCreateForm()
        applyCountTypeFilter(
          revealCreatedTakeInHistory({
            venueId,
            currentFilter: countTypeFilter,
            created,
            supplierIds: payload.supplierIds,
          }),
        )
        const createdId = created?._id || created?.id
        if (createdId) history.push(`/v/${venueId}/stockTakes/${createdId}`)
        return created
      })
      .finally(() => {
        creatingRef.current = false
        setIsCreating(false)
      })
  }

  const handleCreateButtonWithPrev = () => {
    submitStockTakeCreate({ prevStockTake: stocks[0]._id })
  }

  const handleCreateButtonWithoutPrev = () => {
    submitStockTakeCreate({})
  }

  const beginFirstStockTake = () => {
    if (creatingRef.current) return Promise.resolve(false)
    creatingRef.current = true
    setIsCreating(true)
    const [defaultStart, defaultEnd] = defaultStockTakeCreatePeriod()
    const payload = buildStockTakeCreatePayload({
      startDate: dateOfCreation[0] || defaultStart,
      endDate: dateOfCreation[1] || defaultEnd,
      name: stockTakeName,
      supplierIds: createSupplierIds,
      supplierTitles: supplierTitlesForCreateIds(
        createSupplierIds,
        createSupplierOptions,
      ),
      countMetadata,
    })
    return dispatch(createStock(payload, venueId))
      .then(created => {
        resetCreateForm()
        applyCountTypeFilter(
          revealCreatedTakeInHistory({
            venueId,
            currentFilter: countTypeFilter,
            created,
            supplierIds: payload.supplierIds,
          }),
        )
        const createdId = created?._id || created?.id
        if (createdId) history.push(`/v/${venueId}/stockTakes/${createdId}`)
        return created
      })
      .finally(() => {
        creatingRef.current = false
        setIsCreating(false)
      })
  }
  const suggestedEmpty = bindGuidedEmptySuggestedActions({
    venueId,
    featureId: 'stock_takes',
    suggested,
    onStart: beginFirstStockTake,
  })

  const onChangeDate = (value, dateString) => {
    setVisibleCalendar(false)
    if (dateString && (dateString[0] || dateString[1])) {
      setDateOfCreation(dateString)
      setCreateSupplierIds([])
    } else {
      setDateOfCreation([])
    }
  }

  const handleWastageWaitingNextStep = next => {
    if (!next) return
    if (next.kind === 'open' || next.kind === 'continue') {
      const id = next.stockTake?._id || next.stockTake?.id
      if (id) history.push(`/v/${venueId}/stockTakes/${id}`)
      return
    }
    const day = next.waitingDay || wastageLondonToday()
    onChangeDate(null, [day, day])
    createFormRef.current?.scrollIntoView?.({
      block: 'nearest',
      behavior: 'smooth',
    })
  }

  const disabledDates = current => {
    for (const stock of stocks) {
      current._d.setHours(0)
      current._d.setMinutes(0)
      const isLessCurrentInRange = current <= moment(stock.toPeriod)
      const isGreaterThanMoment = current > moment.now()
      current._d.setHours(23)
      current._d.setMinutes(59)
      const isGreaterCurrentInRange = current >= moment(stock.fromPeriod)

      if (
        (isLessCurrentInRange && isGreaterCurrentInRange) ||
        isGreaterThanMoment
      ) {
        return true
      }
    }
    return false
  }

  const loadingButton = (item, type, icon) => {
    return buttonLoading.isLoading === true &&
      buttonLoading.stockTake === item._id &&
      buttonLoading.buttonType === type ? (
      <LoadingOutlined />
    ) : (
      icon
    )
  }

  const isSupplierScopedCreate = Boolean(
    uniqueStockTakeSupplierIds(createSupplierIds).length,
  )
  const createPathArgs = {
    startDate: dateOfCreation[0],
    endDate: dateOfCreation[1],
    supplierIds: createSupplierIds,
  }
  const createDatesDisabled =
    isCreating || isStockTakeCreateDatesDisabled(createPathArgs)
  const createSuppliersDisabled =
    isCreating || isStockTakeCreateSuppliersDisabled(createPathArgs)
  const createDisabled = isCreating || !canSubmitStockTakeCreate(createPathArgs)
  const showCreateCtaHint = !canSubmitStockTakeCreate(createPathArgs)

  const formatMoney = formatGbp

  const formatAuditTimestamp = value => {
    if (!value) return 'N/A'
    return dayjs(value).format('DD MMM YYYY, HH:mm')
  }

  const normalizeCountType = stockTake => {
    const countType = String(stockTake?.countType || '').toUpperCase()
    if (countType === 'PARTIAL') return 'PARTIAL'
    return 'MAIN'
  }

  const getReportLink = (item, reportType) => {
    const basePath = `/v/${venueId}/stockTakes/${item._id}/${reportType}`
    return normalizeCountType(item) === 'PARTIAL'
      ? `${basePath}?view=partial`
      : basePath
  }

  const canUseReports = canUseStockTakeReports(currentPlan)

  const renderListReport = (item, { label, reportType }) => {
    const disabledCopy = stockTakeListReportDisabledCopy({
      isLocked: item.isLocked,
      canUseReports,
    })
    if (!disabledCopy) {
      return (
        <CustomButton as={Link} to={getReportLink(item, reportType)}>
          {label}
        </CustomButton>
      )
    }
    return (
      <Tooltip title={disabledCopy}>
        <span>
          <ReportDisabledButton type='button' disabled>
            {label}
          </ReportDisabledButton>
        </span>
      </Tooltip>
    )
  }

  const fetchPartialGroups = async () => {
    try {
      const groups = await API.get('api2', `venue/${venueId}/stocks/groups`)
      setPartialGroups(Array.isArray(groups) ? groups : [])
    } catch (error) {
      console.error('Failed to fetch partial groups:', error)
      setPartialGroups([])
    }
  }

  const fetchLinkedGroups = async () => {
    try {
      const groups = await API.get(
        'api2',
        `venue/${venueId}/stocks/linked-groups`,
      )
      setLinkedGroups(Array.isArray(groups) ? groups : [])
    } catch (error) {
      console.error('Failed to fetch linked groups:', error)
      setLinkedGroups([])
    }
  }

  const resolvePrimaryStockTakeId = () =>
    stocks.find(item => normalizeCountType(item) === 'MAIN')?._id ||
    stocks[0]?._id ||
    null

  const fetchGroupProductCandidates = async () => {
    const targetStockTakeId = resolvePrimaryStockTakeId()
    if (!targetStockTakeId) {
      setPartialGroupProducts([])
      return []
    }
    const products = await API.get(
      'api2',
      `venue/${venueId}/stocks/${targetStockTakeId}/products`,
    )
    const normalizedProducts = (Array.isArray(products) ? products : [])
      .map(product => {
        const selectionKey = [
          String(product?.title || '')
            .trim()
            .toLowerCase(),
          String(product?.supplierTitle || '')
            .trim()
            .toLowerCase(),
          String(product?.sku || '')
            .trim()
            .toLowerCase(),
          String(product?.size || '')
            .trim()
            .toLowerCase(),
          String(product?.UoM || '')
            .trim()
            .toLowerCase(),
        ].join('::')
        if (!selectionKey || selectionKey === '::::') return null
        return {
          selectionKey,
          label: [
            product?.title || 'Untitled product',
            product?.supplierTitle ? `• ${product.supplierTitle}` : null,
            product?.sku ? `• SKU ${product.sku}` : null,
          ]
            .filter(Boolean)
            .join(' '),
          title: product?.title || '',
          supplierTitle: product?.supplierTitle || '',
          type: product?.type || '',
          sku: product?.sku || '',
          stockTakeProductId: product?._id || product?.id || null,
          venueProductId:
            product?.venueProductId ||
            product?.productId ||
            product?.product?._id ||
            null,
        }
      })
      .filter(Boolean)
    setPartialGroupProducts(normalizedProducts)
    return normalizedProducts
  }

  const handleOpenManageGroups = async () => {
    await Promise.all([fetchPartialGroups(), fetchGroupProductCandidates()])
    setManageGroupsVisible(true)
  }

  const handleOpenLinkProducts = async () => {
    const targetStockTakeId = resolvePrimaryStockTakeId()

    if (!targetStockTakeId) {
      Modal.info({
        title: 'No stock take available',
        content: 'Create a stock take first, then link products.',
      })
      return
    }

    try {
      const [products, venueProducts] = await Promise.all([
        API.get(
          'api2',
          `venue/${venueId}/stocks/${targetStockTakeId}/products`,
          { queryStringParameters: { unmerged: 'true' } },
        ),
        API.get('api', `venue/${venueId}/products`),
      ])
      const normalizeValue = value =>
        String(value || '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, ' ')
          .trim()
      const buildKey = (...parts) => parts.map(normalizeValue).join('::')
      const toArrayMap = (map, key, value) => {
        const existing = map.get(key) || []
        existing.push(value)
        map.set(key, existing)
      }
      const pickBestVenueProduct = (candidates = [], stockProduct = {}) => {
        if (!Array.isArray(candidates) || !candidates.length) return null
        const stockUoM = normalizeValue(stockProduct?.UoM)
        const stockSku = normalizeValue(stockProduct?.sku)
        const ranked = [...candidates].sort((left, right) => {
          const leftUoM = normalizeValue(left?.UoM || left?.product?.UoM)
          const rightUoM = normalizeValue(right?.UoM || right?.product?.UoM)
          const leftSku = normalizeValue(left?.product?.sku || left?.sku)
          const rightSku = normalizeValue(right?.product?.sku || right?.sku)
          const leftConversions = Array.isArray(left?.conversions)
            ? left.conversions.length
            : 0
          const rightConversions = Array.isArray(right?.conversions)
            ? right.conversions.length
            : 0
          const leftScore =
            (stockUoM && leftUoM === stockUoM ? 4 : 0) +
            (stockSku && leftSku === stockSku ? 3 : 0) +
            (leftConversions > 0 ? 1 : 0)
          const rightScore =
            (stockUoM && rightUoM === stockUoM ? 4 : 0) +
            (stockSku && rightSku === stockSku ? 3 : 0) +
            (rightConversions > 0 ? 1 : 0)
          return rightScore - leftScore
        })
        return ranked[0] || null
      }

      const venueProductsList = Array.isArray(venueProducts)
        ? venueProducts
        : []
      const venueProductById = new Map()
      const venueProductsByTitleSupplierSku = new Map()
      const venueProductsBySkuSupplier = new Map()
      const venueProductsByTitleSku = new Map()
      const venueProductsByTitle = new Map()

      venueProductsList.forEach(vp => {
        const vpId = String(vp?._id || '')
        if (vpId) venueProductById.set(vpId, vp)
        const title = vp?.title || vp?.product?.title
        const supplier = vp?.supplierTitle || vp?.product?.supplier?.title
        const sku = vp?.product?.sku || vp?.sku
        toArrayMap(
          venueProductsByTitleSupplierSku,
          buildKey(title, supplier, sku),
          vp,
        )
        toArrayMap(venueProductsBySkuSupplier, buildKey(sku, supplier), vp)
        toArrayMap(venueProductsByTitleSku, buildKey(title, sku), vp)
        toArrayMap(venueProductsByTitle, buildKey(title), vp)
      })

      const enrichedProducts = (Array.isArray(products) ? products : []).map(
        product => {
          const directVenueProductId =
            product?.venueProductId ||
            product?.productId ||
            product?.linkedStockGroupProfile?.sourceVenueProductId ||
            null
          const directVenueProduct = directVenueProductId
            ? venueProductById.get(String(directVenueProductId))
            : null
          const candidates = directVenueProduct
            ? [directVenueProduct]
            : [
                ...(venueProductsByTitleSupplierSku.get(
                  buildKey(
                    product?.title,
                    product?.supplierTitle,
                    product?.sku,
                  ),
                ) || []),
                ...(venueProductsBySkuSupplier.get(
                  buildKey(product?.sku, product?.supplierTitle),
                ) || []),
                ...(venueProductsByTitleSku.get(
                  buildKey(product?.title, product?.sku),
                ) || []),
                ...(venueProductsByTitle.get(buildKey(product?.title)) || []),
              ]
          const venueProduct = pickBestVenueProduct(candidates, product)
          const conversions = Array.isArray(venueProduct?.conversions)
            ? venueProduct.conversions.map(conversion => ({
                conversionId: conversion?._id || conversion?.id || null,
                label:
                  conversion?.label ||
                  conversion?.title ||
                  conversion?.name ||
                  'Conversion',
                toUnit: conversion?.toUnit || conversion?.toUoM || '',
                toQty:
                  Number(conversion?.toQty ?? conversion?.factor ?? 0) || 0,
              }))
            : []
          return {
            ...product,
            venueProductId:
              venueProduct?._id || product?.venueProductId || null,
            conversions,
          }
        },
      )
      setLinkableProducts(enrichedProducts)
      await fetchLinkedGroups()
      setLinkProductsVisible(true)
    } catch (error) {
      console.error('Failed to load products for linking:', error)
      Modal.error({
        title: 'Unable to load products',
        content: 'Please try again in a moment.',
      })
    }
  }

  const handleCreateGroup = async payload => {
    await API.post('api2', `venue/${venueId}/stocks/groups`, { body: payload })
    await fetchPartialGroups()
  }

  const handleUpdateGroup = async (groupId, payload) => {
    await API.patch('api2', `venue/${venueId}/stocks/groups/${groupId}`, {
      body: payload,
    })
    await fetchPartialGroups()
  }

  const handleDeleteGroup = async groupId => {
    await API.del('api2', `venue/${venueId}/stocks/groups/${groupId}`)
    await fetchPartialGroups()
  }

  const handleDuplicateGroup = async group => {
    if (!group) return
    const duplicateNameBase = String(group?.name || 'Partial Group').trim()
    const payload = {
      name: `${duplicateNameBase} (Copy)`,
      notes: String(group?.notes || '').trim(),
      productIds: Array.isArray(group?.productIds) ? group.productIds : [],
      venueProductIds: Array.isArray(group?.venueProductIds)
        ? group.venueProductIds
        : [],
      productKeys: Array.isArray(group?.productKeys) ? group.productKeys : [],
    }
    await handleCreateGroup(payload)
  }

  const handleCreateLinkedProductsProfile = async payload => {
    await API.post('api2', `venue/${venueId}/stocks/linked-groups`, {
      body: payload,
    })
    await fetchLinkedGroups()
    dispatch(fetchStockTakes(venueId))
  }

  const handleUpdateLinkedProductsProfile = async (linkedGroupId, payload) => {
    await API.patch(
      'api2',
      `venue/${venueId}/stocks/linked-groups/${linkedGroupId}`,
      {
        body: payload,
      },
    )
    await fetchLinkedGroups()
    dispatch(fetchStockTakes(venueId))
  }

  const handleDeleteLinkedProductsProfile = async linkedGroupId => {
    if (!linkedGroupId) return
    await API.del(
      'api2',
      `venue/${venueId}/stocks/linked-groups/${linkedGroupId}`,
    )
    await fetchLinkedGroups()
    dispatch(fetchStockTakes(venueId))
  }

  const handleDuplicateLinkedProductsProfile = async group => {
    if (!group) return
    const baseName = String(
      group?.displayName || group?.groupName || 'Linked Product',
    ).trim()
    const payload = {
      groupName: `${baseName} (Copy)`,
      displayName: `${baseName} (Copy)`,
      displaySku: String(group?.displaySku || '').trim(),
      displayUoM: String(group?.displayUoM || '').trim(),
      displayConversionOptions: Array.isArray(group?.displayConversionOptions)
        ? group.displayConversionOptions
        : [],
      memberMappings: Array.isArray(group?.memberMappings)
        ? group.memberMappings
        : [],
      linkedProductIds: Array.isArray(group?.linkedProductIds)
        ? group.linkedProductIds
        : [],
      manualStockValue: Number(group?.manualStockValue) || 0,
      note: String(group?.note || '').trim(),
    }
    await handleCreateLinkedProductsProfile(payload)
  }

  const handleSaveCountMetadataDefaults = async () => {
    if (!venueId) return
    await dispatch(
      editVenue(
        {
          stockTakeDefaultSiteManager: countMetadata.siteManager,
          stockTakeDefaultLineManager: countMetadata.lineManager,
          stockTakeDefaultCountNotes: countMetadata.countNotes,
        },
        venueId,
      ),
    )
    setCountMetadataSaved(true)
    setTimeout(() => setCountMetadataSaved(false), 1800)
  }

  const partialGroupNameById = useMemo(() => {
    const pairs = (partialGroups || [])
      .map(group => {
        const id = String(group?._id || group?.id || '')
        if (!id) return null
        return [
          id,
          {
            name: group?.name || 'Untitled group',
            productCount:
              group?.productCount ||
              group?.venueProductIds?.length ||
              group?.productKeys?.length ||
              group?.productIds?.length ||
              0,
          },
        ]
      })
      .filter(Boolean)
    return Object.fromEntries(pairs)
  }, [partialGroups])

  const getPartialGroupLabel = stockTake => {
    const meta = getPartialCardMeta(stockTake, partialGroupNameById)
    if (meta.kind === 'supplier' || !meta.name) {
      return stockTake?.partialGroupName || stockTake?.partialGroup?.name || ''
    }
    return meta.name
  }

  const getLockAuditEvents = item => {
    const events = Array.isArray(item?.lockAuditEvents)
      ? [...item.lockAuditEvents]
      : []
    return events.sort(
      (a, b) => dayjs(b?.at).valueOf() - dayjs(a?.at).valueOf(),
    )
  }

  const openAuditModal = item => {
    const events = getLockAuditEvents(item)
    const latestUnlockEvent = events.find(event => event?.action === 'UNLOCK')
    Modal.info({
      title: 'Stock take audit trail',
      width: 700,
      content: (
        <AuditPanel>
          <AuditHeaderRow>
            <strong>Current status:</strong>{' '}
            {item?.isLocked ? 'Locked' : 'Unlocked'}
          </AuditHeaderRow>
          {wasStockTakeUnlocked(item) ? (
            <AuditSummary>
              <div>
                <strong>Unlocked by:</strong>{' '}
                {latestUnlockEvent?.actorName || 'Unknown user'}
              </div>
              <div>
                <strong>Unlocked at:</strong>{' '}
                {formatAuditTimestamp(item?.unlockedAt)}
              </div>
              <div>
                <strong>Unlock reason:</strong>{' '}
                {item?.unlockReason || 'No reason provided'}
              </div>
            </AuditSummary>
          ) : null}
          <AuditTopTitle>Event history</AuditTopTitle>
          {events.length ? (
            events.map((event, index) => (
              <AuditEvent key={`${event?.action}-${event?.at}-${index}`}>
                <span>
                  <strong>{event?.action || 'UNKNOWN'}</strong> by{' '}
                  {event?.actorName || 'Unknown user'}
                </span>
                <span>{formatAuditTimestamp(event?.at)}</span>
                {event?.reason ? (
                  <AuditReason>Reason: {event.reason}</AuditReason>
                ) : null}
              </AuditEvent>
            ))
          ) : (
            <ReviewMutedText>No audit events available yet.</ReviewMutedText>
          )}
        </AuditPanel>
      ),
      okText: 'Close',
    })
  }

  const zeroStockKey = stocks
    .filter(stockTake => {
      const value = Number(stockTake?.totalStockValue)
      return !Number.isFinite(value) || value === 0
    })
    .map(stockTake => String(stockTake._id))
    .join(',')

  useEffect(() => {
    if (!venueId || !zeroStockKey) return undefined
    let cancelled = false
    const ids = zeroStockKey.split(',')
    Promise.all(
      ids.map(id =>
        API.get('api2', `venue/${venueId}/stocks/${id}/products`)
          .then(products => [
            id,
            stockLinesWereCounted(Array.isArray(products) ? products : []),
          ])
          .catch(() => null),
      ),
    )
      .then(pairs => {
        if (cancelled) return null
        setLinesCountedById(current => ({
          ...current,
          ...Object.fromEntries(pairs.filter(Boolean)),
        }))
        return null
      })
      .catch(() => null)
    return () => {
      cancelled = true
    }
  }, [venueId, zeroStockKey])

  const venueSupplierIds = useMemo(
    () => createSupplierOptions.map(option => option.value),
    [createSupplierOptions],
  )
  const latestRepeatableStockTake = useMemo(
    () => pickLatestRepeatableStockTake(stocks, { venueSupplierIds }),
    [stocks, venueSupplierIds],
  )
  const openRepeatableStockTake = useMemo(
    () => pickOpenRepeatableStockTake(stocks, { venueSupplierIds }),
    [stocks, venueSupplierIds],
  )
  const showCountAgainHero = shouldShowCountAgainHero(countTypeFilter)
  const heroRepeatStockTake = showCountAgainHero
    ? latestRepeatableStockTake
    : openRepeatableStockTake
  const heroRepeatLabel = !heroRepeatStockTake
    ? ''
    : showCountAgainHero
    ? stockTakeRepeatAgainLabel(heroRepeatStockTake)
    : stockTakeOpenTodayLabel(heroRepeatStockTake)
  const historySupplierOptions = useMemo(
    () =>
      listStockTakeHistorySupplierOptions({
        stockTakes: filterEmptySupplierCloneTakes(stocks),
        venueOptions: createSupplierOptions,
      }),
    [createSupplierOptions, stocks],
  )
  const filteredStocks = filterStockTakeHistory(
    filterEmptySupplierCloneTakes(stocks).map(stockTake => {
      const groupName = getPartialGroupLabel(stockTake)
      return {
        ...stockTake,
        partialGroupName: groupName || stockTake?.partialGroupName,
        listHeading: getStockTakePageHeading({
          ...stockTake,
          partialGroupName: groupName || stockTake?.partialGroupName,
        }),
      }
    }),
    {
      countTypeFilter,
      partialGroupFilter,
      partialGroupLabel: getPartialGroupLabel,
      search: historySearch,
      supplierIds: historySupplierIds,
      dateRange: historyDateRange,
    },
  )
  const hasAnyPartialStock = stocks.some(
    stockTake => normalizeCountType(stockTake) === 'PARTIAL',
  )
  const hiddenSupplierCount = countHiddenSupplierTakes(stocks, countTypeFilter)
  const hiddenSupplierLine =
    stockTakeHiddenSupplierCountsLine(hiddenSupplierCount)
  const partialGroupComboboxVisible =
    shouldShowPartialGroupCombobox(countTypeFilter)
  const partialGroupFilterHelperVisible =
    shouldShowPartialGroupFilterHelper(countTypeFilter)
  const listEmptyState = (() => {
    if (stocks.length === 0)
      return 'No stock takes yet. Create your first one above.'
    if (countTypeFilter === 'PARTIAL' && !hasAnyPartialStock) {
      return (
        <EmptyStateBox>
          <div>No partial counts yet. Count suppliers above.</div>
        </EmptyStateBox>
      )
    }
    if (
      String(historySearch || '').trim() ||
      (Array.isArray(historySupplierIds) && historySupplierIds.length) ||
      (historyDateRange?.start && historyDateRange?.end)
    ) {
      return 'No stock takes match that name, group, supplier, or dates.'
    }
    if (partialGroupFilter !== 'ALL') {
      return (
        <EmptyStateBox>
          <div>{`No partial counts found for "${partialGroupFilter}". Count suppliers above.`}</div>
        </EmptyStateBox>
      )
    }
    return 'No stock takes match this filter.'
  })()

  return (
    <div>
      {/*
        Stock Management Made Simple onboarding video — disabled (out of date).
        We may want to update and re-enable this with a current walkthrough in the future.
      */}
      {false && (
        <Collapse style={{ width: '50%', margin: '0 auto 20px' }}>
          <Panel
            header={
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <span>📦</span>
                <strong>Stock Management Made Simple!</strong>
              </div>
            }
            key='banner'
          >
            <div
              style={{
                width: '100%',
                margin: 0,
                textAlign: 'left',
                maxWidth: '900px',
              }}
            >
              <p style={{ fontSize: 20, marginBottom: 10 }}>
                📦 <strong>Stock Management Made Simple!</strong>
              </p>
              <p>
                Your supplier prices pull through automatically - no need to
                update prices manually!
              </p>
              <p>
                💡 <strong>This tool helps you:</strong>
              </p>
              <video
                controls
                style={{
                  width: '100%',
                  maxWidth: '600px',
                  borderRadius: '8px',
                  marginBottom: '16px',
                  marginTop: '10px',
                  boxSizing: 'border-box',
                  border: '1px solid #ddd',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                <source src='' type='video/mp4' />
                Your browser does not support the video tag.
              </video>
              <ul style={{ marginLeft: 20 }}>
                <li>Track wastage alongside stock</li>
                <li>See total stock and wastage values</li>
                <li>
                  Maintain accurate stock reporting with live supplier prices
                </li>
              </ul>
            </div>
          </Panel>
        </Collapse>
      )}

      {isLoading ? (
        <Loading />
      ) : (
        <StockTakesAboveFoldLayout
          liftEmpty={liftStockTakesEmpty}
          why={
            showStockTakesGuidedEmpty ? (
              <GrowthEngineFeatureEmptyState
                featureId='stock_takes'
                title={guidedSuccess.emptyState.title}
                body={guidedSuccess.emptyState.body}
                valueLine={guidedSuccess.emptyState.valueLine}
                estimatedMinutes={guidedSuccess.emptyState.estimatedMinutes}
                ctaLabel={guidedSuccess.emptyState.cta?.label}
                onCta={suggestedEmpty.onCta}
                suggestedItems={suggestedEmpty.suggestedItems}
                onSuggestedItem={suggestedEmpty.onSuggestedItem}
                onSuggestedEdit={suggestedEmpty.onSuggestedEdit}
                onRejectSuggested={suggestedEmpty.onRejectSuggested}
                askOllieQuestion={
                  progressHandoff?.fromProgress
                    ? resolveProgressAskOllie(
                        progressHandoff?.featureId || 'stock_takes',
                      )?.question
                    : null
                }
                askOllieLabel={
                  resolveProgressAskOllie(
                    progressHandoff?.featureId || 'stock_takes',
                  )?.label
                }
              />
            ) : null
          }
        >
          {ollieRow}
          <StockHeroBand>
            <StockHeaderRow>
              <div>
                <StockPageTitle>Your stock takes</StockPageTitle>
                <StockHeroIntro>{STOCK_TAKE_LIST_SUBTITLE}</StockHeroIntro>
                <StockHeroJobs data-testid='stock-take-create-paths-hint'>
                  <StockHeroJob>{STOCK_TAKE_JOB_SUPPLIER}</StockHeroJob>
                  <StockHeroJob>{STOCK_TAKE_JOB_HOUSE}</StockHeroJob>
                </StockHeroJobs>
                {(partialGroups || []).length > 0 && (
                  <CountSheetShare data-testid='stock-count-sheet-share'>
                    <Select
                      style={{ width: 240 }}
                      value={
                        (partialGroups || []).some(
                          group => (group?._id || group?.id) === shareSheetId,
                        )
                          ? shareSheetId
                          : partialGroups[0]?._id || partialGroups[0]?.id
                      }
                      onChange={value => setShareSheetId(value)}
                      data-testid='stock-count-sheet-share-select'
                    >
                      {(partialGroups || []).map(group => {
                        const groupId = group?._id || group?.id
                        if (!groupId) return null
                        return (
                          <Select.Option key={groupId} value={groupId}>
                            {group?.name || 'Untitled group'}
                          </Select.Option>
                        )
                      })}
                    </Select>
                    <ShareWithGroupButton
                      offer={{
                        kind: 'stockCountSheet',
                        venueId,
                        groupId: (partialGroups || []).some(
                          group => (group?._id || group?.id) === shareSheetId,
                        )
                          ? shareSheetId
                          : partialGroups[0]?._id || partialGroups[0]?.id,
                      }}
                      label='Share this count sheet…'
                    />
                  </CountSheetShare>
                )}
              </div>
            </StockHeaderRow>
            <HeroCreateForm
              ref={createFormRef}
              data-testid='stock-take-create-row'
            >
              <CreateField>
                <CreateFieldLabel htmlFor='stock-take-create-name'>
                  Name (optional)
                </CreateFieldLabel>
                <Input
                  id='stock-take-create-name'
                  data-testid='stock-take-create-name'
                  placeholder='e.g. Month end'
                  value={stockTakeName}
                  onChange={event => setStockTakeName(event.target.value)}
                  allowClear
                  disabled={isCreating}
                />
              </CreateField>
              <CreatePathGrid>
                <CreatePathCard
                  data-testid='stock-take-create-supplier-path'
                  $inactive={createSuppliersDisabled}
                >
                  <CreatePathTitle>
                    {STOCK_TAKE_CREATE_SUPPLIER_HEADING}
                  </CreatePathTitle>
                  <CreatePathBody data-testid='stock-take-create-supplier-body'>
                    {STOCK_TAKE_CREATE_SUPPLIER_BODY}
                  </CreatePathBody>
                  {createSuppliersDisabled ? (
                    <CreatePathWhy data-testid='stock-take-create-why-dates'>
                      {STOCK_TAKE_CREATE_WHY_DATES}
                    </CreatePathWhy>
                  ) : null}
                  <CreateFieldLabel htmlFor='stock-take-create-suppliers'>
                    {STOCK_TAKE_CREATE_SUPPLIERS_LABEL}
                  </CreateFieldLabel>
                  <Select
                    id='stock-take-create-suppliers'
                    data-testid='stock-take-create-suppliers'
                    mode='multiple'
                    allowClear
                    showSearch
                    optionFilterProp='children'
                    placeholder={STOCK_TAKE_CREATE_SUPPLIERS_PLACEHOLDER}
                    value={createSupplierIds}
                    onChange={value => {
                      const next = Array.isArray(value) ? value : []
                      setCreateSupplierIds(next)
                      if (uniqueStockTakeSupplierIds(next).length) {
                        clearCreateDates()
                      }
                    }}
                    disabled={createSuppliersDisabled}
                    dropdownMatchSelectWidth={false}
                    style={{ minWidth: 0, width: '100%' }}
                  >
                    {createSupplierOptions.map(option => (
                      <Select.Option key={option.value} value={option.value}>
                        {option.label}
                      </Select.Option>
                    ))}
                  </Select>
                </CreatePathCard>
                <CreatePathCard
                  data-testid='stock-take-create-house-path'
                  $inactive={createDatesDisabled}
                >
                  <CreatePathTitle>
                    {STOCK_TAKE_CREATE_HOUSE_HEADING}
                  </CreatePathTitle>
                  <CreatePathBody data-testid='stock-take-create-house-body'>
                    {STOCK_TAKE_CREATE_HOUSE_BODY}
                  </CreatePathBody>
                  {createDatesDisabled ? (
                    <CreatePathWhy data-testid='stock-take-create-why-suppliers'>
                      {STOCK_TAKE_CREATE_WHY_SUPPLIERS}
                    </CreatePathWhy>
                  ) : null}
                  <CreateFieldLabel>
                    {STOCK_TAKE_CREATE_DATES_LABEL}
                  </CreateFieldLabel>
                  <CreatePeriodRow>
                    <RangePicker
                      onFocus={() => setVisibleCalendar(true)}
                      onBlur={() => setVisibleCalendar(false)}
                      open={visibleCalendar}
                      ref={refToSelectDate}
                      disabledDate={disabledDates}
                      onChange={onChangeDate}
                      disabled={createDatesDisabled}
                      value={
                        dateOfCreation[0] && dateOfCreation[1]
                          ? [
                              moment(dateOfCreation[0]),
                              moment(dateOfCreation[1]),
                            ]
                          : null
                      }
                    />
                  </CreatePeriodRow>
                </CreatePathCard>
              </CreatePathGrid>
              {stocks.length > 0 && !isSupplierScopedCreate ? (
                <Popconfirm
                  onConfirm={handleCreateButtonWithPrev}
                  onCancel={handleCreateButtonWithoutPrev}
                  title='Do you want to get data from last stock take?'
                  okText='Yes'
                  cancelText='No'
                >
                  <CreatePathCta
                    data-testid='stock-take-create'
                    disabled={createDisabled}
                  >
                    {isCreating ? 'Creating…' : 'Create'}
                  </CreatePathCta>
                </Popconfirm>
              ) : (
                <CreatePathCta
                  data-testid='stock-take-create'
                  onClick={handleCreateButtonWithoutPrev}
                  disabled={createDisabled}
                >
                  {isCreating ? 'Creating…' : 'Create'}
                </CreatePathCta>
              )}
              {showCreateCtaHint ? (
                <CreatePathWhy data-testid='stock-take-create-cta-hint'>
                  {STOCK_TAKE_CREATE_CTA_HINT}
                </CreatePathWhy>
              ) : null}
              {heroRepeatStockTake ? (
                <Tooltip
                  title={
                    showCountAgainHero
                      ? 'Starts a new blank count with the same suppliers and name. Quantities are not copied.'
                      : 'Opens today’s supplier count. Create stays empty on Main.'
                  }
                >
                  <StockQuietButton
                    data-testid='stock-take-repeat-latest'
                    disabled={isCreating}
                    onClick={() => handleRepeatStockTake(heroRepeatStockTake)}
                  >
                    <RedoOutlined />
                    {heroRepeatLabel}
                  </StockQuietButton>
                </Tooltip>
              ) : null}
            </HeroCreateForm>
          </StockHeroBand>
          <WasteHomeCard
            venueId={venueId}
            stockTakes={stocks}
            onWaitingNextStep={handleWastageWaitingNextStep}
          />
          <GrowthEngineProgressAskOllie
            featureId={progressHandoff?.featureId || 'stock_takes'}
            enabled={
              Boolean(progressHandoff?.fromProgress) &&
              !showStockTakesGuidedEmpty
            }
          />
          <Collapse style={{ marginBottom: 12 }}>
            <Panel
              header='Additional count details (optional)'
              key='additional-count-details'
            >
              <CountDetailsIntro>
                These details are attached to new stock takes you create,
                including both Main Stock Takes and Partial Counts.
              </CountDetailsIntro>
              <CountDetailsGrid>
                <div>
                  <CountDetailsLabel>
                    Site name{' '}
                    <Tooltip title='Locked for audit integrity.'>
                      <LockOutlined />
                    </Tooltip>
                  </CountDetailsLabel>
                  <Input value={countMetadata.siteName} disabled />
                  <CountDetailsHint>
                    Auto-set from venue for audit security.
                  </CountDetailsHint>
                </div>
                <div>
                  <CountDetailsLabel>Site manager</CountDetailsLabel>
                  <Input
                    value={countMetadata.siteManager}
                    placeholder='Site manager'
                    onChange={event =>
                      setCountMetadata(prev => ({
                        ...prev,
                        siteManager: event.target.value,
                      }))
                    }
                  />
                </div>
                <div>
                  <CountDetailsLabel>Line manager</CountDetailsLabel>
                  <Input
                    value={countMetadata.lineManager}
                    placeholder='Line manager'
                    onChange={event =>
                      setCountMetadata(prev => ({
                        ...prev,
                        lineManager: event.target.value,
                      }))
                    }
                  />
                </div>
                <div>
                  <CountDetailsLabel>
                    Counted by{' '}
                    <Tooltip title='Locked for audit integrity.'>
                      <LockOutlined />
                    </Tooltip>
                  </CountDetailsLabel>
                  <Input value={countMetadata.countedByName} disabled />
                  <CountDetailsHint>
                    Auto-set from logged-in user for audit security.
                  </CountDetailsHint>
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <CountDetailsLabel>Notes</CountDetailsLabel>
                  <Input.TextArea
                    rows={3}
                    value={countMetadata.countNotes}
                    placeholder='Add optional details for audit history and reporting'
                    onChange={event =>
                      setCountMetadata(prev => ({
                        ...prev,
                        countNotes: event.target.value,
                      }))
                    }
                  />
                </div>
              </CountDetailsGrid>
              <CountDetailsActions>
                {countMetadataSaved ? (
                  <CountDetailsSaved>
                    <div>✓ Saved</div>
                    <CountDetailsSavedHint>
                      Applies to your next created stock take.
                    </CountDetailsSavedHint>
                  </CountDetailsSaved>
                ) : (
                  <StockQuietButton onClick={handleSaveCountMetadataDefaults}>
                    Save details
                  </StockQuietButton>
                )}
              </CountDetailsActions>
            </Panel>
          </Collapse>
          <QuietActions data-testid='stock-quiet-actions'>
            <Collapse defaultActiveKey={[]}>
              <Panel header={STOCK_TAKE_QUIET_DRAWER_TITLE} key='quiet'>
                {accessChrome}
                <GroupsWhyLine>{STOCK_TAKE_GROUPS_WHY_LINE}</GroupsWhyLine>
                <QuietActionRow>
                  <StockQuietButton onClick={handleOpenManageGroups}>
                    Manage groups
                  </StockQuietButton>
                  <StockQuietButton onClick={handleOpenLinkProducts}>
                    Link products
                  </StockQuietButton>
                </QuietActionRow>
                <StockSettingsPanel
                  autoEmailEnabled={Boolean(venue?.stockTakeAutoEmailEnabled)}
                  recipients={venue?.stockTakeReportEmails || []}
                  onChange={payload => dispatch(editVenue(payload, venueId))}
                />
                <EmailHelperCopy>
                  Variance emails include count type (Main or Partial). For
                  partial counts, the partial group name is included.
                </EmailHelperCopy>
              </Panel>
            </Collapse>
          </QuietActions>
          <Divider orientation='left'>Previous stock takes</Divider>
          <FilterHint>
            Filter by Main or Partial, search by name, pick suppliers, or dates.
          </FilterHint>
          <Input.Search
            allowClear
            data-testid='stock-take-history-search'
            placeholder={STOCK_TAKE_HISTORY_SEARCH_PLACEHOLDER}
            value={historySearch}
            onChange={event => setHistorySearch(event.target.value)}
            style={{ maxWidth: 360, marginBottom: 12 }}
          />
          {historySupplierOptions.length ? (
            <div data-testid='stock-take-history-suppliers'>
              <Select
                mode='multiple'
                allowClear
                placeholder={STOCK_TAKE_HISTORY_SUPPLIER_PLACEHOLDER}
                value={historySupplierIds}
                onChange={value => setHistorySupplierIds(value || [])}
                optionFilterProp='children'
                style={{ minWidth: 240, maxWidth: 420, marginBottom: 12 }}
              >
                {historySupplierOptions.map(option => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          ) : null}
          <div data-testid='stock-take-history-dates'>
            <RangePicker
              allowClear
              placeholder={[
                STOCK_TAKE_HISTORY_DATE_PLACEHOLDER,
                STOCK_TAKE_HISTORY_DATE_PLACEHOLDER,
              ]}
              value={
                historyDateRange?.start && historyDateRange?.end
                  ? [
                      moment(historyDateRange.start),
                      moment(historyDateRange.end),
                    ]
                  : null
              }
              onChange={dates => {
                if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
                  setHistoryDateRange(null)
                  return
                }
                setHistoryDateRange({
                  start: dates[0].clone().startOf('day').toISOString(),
                  end: dates[1].clone().endOf('day').toISOString(),
                })
              }}
              style={{ marginBottom: 12 }}
            />
          </div>
          <FilterBar>
            <FilterChip
              type='button'
              isActive={countTypeFilter === 'ALL'}
              onClick={() => applyCountTypeFilter('ALL')}
            >
              All
            </FilterChip>
            <FilterChip
              type='button'
              isActive={countTypeFilter === 'MAIN'}
              onClick={() => applyCountTypeFilter('MAIN')}
            >
              Main
            </FilterChip>
            <FilterChip
              type='button'
              isActive={countTypeFilter === 'PARTIAL'}
              onClick={() => applyCountTypeFilter('PARTIAL')}
            >
              Partial
            </FilterChip>
          </FilterBar>
          {hiddenSupplierLine ? (
            <FilterSubHint>
              <HiddenCountsButton
                type='button'
                data-testid='stock-take-hidden-supplier-counts'
                onClick={() => {
                  trackStockTakeAnalytics(venueId, {
                    eventName:
                      STOCK_TAKE_ANALYTICS_EVENTS.EMPTY_STATE_CTA_CLICKED,
                    platform: 'dashboard',
                    metadata: { cta: 'show_hidden_supplier_counts' },
                  })
                  applyCountTypeFilter('ALL')
                }}
              >
                {hiddenSupplierLine}
              </HiddenCountsButton>
            </FilterSubHint>
          ) : null}
          {partialGroupComboboxVisible && (
            <FilterBar>
              <Select
                style={{ width: 240 }}
                value={partialGroupFilter}
                onChange={value => setPartialGroupFilter(value)}
                data-testid='stock-take-partial-group-filter'
              >
                <Select.Option value='ALL'>All partial groups</Select.Option>
                {(partialGroups || []).map(group => {
                  const groupId = group?._id || group?.id
                  if (!groupId) return null
                  return (
                    <Select.Option
                      key={`partial-group-filter-${groupId}`}
                      value={group?.name || 'Untitled group'}
                    >
                      {(group?.name || 'Untitled group') +
                        ` (${
                          group?.productCount ||
                          group?.venueProductIds?.length ||
                          group?.productKeys?.length ||
                          group?.productIds?.length ||
                          0
                        })`}
                    </Select.Option>
                  )
                })}
              </Select>
              {partialGroupFilter !== 'ALL' && (
                <ShareWithGroupButton
                  offer={{
                    kind: 'stockCountSheet',
                    venueId,
                    groupId: (partialGroups || []).find(
                      group =>
                        (group?.name || 'Untitled group') ===
                        partialGroupFilter,
                    )?._id,
                  }}
                  label='Share this count sheet…'
                />
              )}
            </FilterBar>
          )}
          {partialGroupFilterHelperVisible && (
            <FilterSubHint>
              Only affects Partial Counts. Main Stock Takes are not included.
            </FilterSubHint>
          )}
          <StockTakeList
            bordered
            dataSource={filteredStocks}
            locale={{
              emptyText: liftStockTakesEmpty
                ? getStockTakesListEmptyCopy(currentPlan, { fromWhy: true })
                : listEmptyState,
            }}
            renderItem={item => {
              const stockText = stockListStockText(
                item.totalStockValue,
                linesCountedById[item._id],
                formatMoney,
              )
              const expectedText = stockListExpectedText(
                item.expectedStockValue,
                formatMoney,
              )
              const overlapCue = formatStockTakeOverlapCue(item, filteredStocks)
              return (
                <List.Item>
                  <StyledRow>
                    <StyledData>
                      {getStockTakeListHeading(item, filteredStocks) ? (
                        <StockTakeName>
                          {getStockTakeListHeading(item, filteredStocks)}
                        </StockTakeName>
                      ) : null}
                      <CountTypeBadge
                        isMain={normalizeCountType(item) === 'MAIN'}
                      >
                        {normalizeCountType(item) === 'MAIN'
                          ? 'Main Stock Take'
                          : 'Partial Count'}
                      </CountTypeBadge>
                      <StockTakeDate>
                        {formatStockTakeDateRange(
                          item.fromPeriod,
                          item.toPeriod,
                        )}
                      </StockTakeDate>
                      {overlapCue ? (
                        <OverlapCue>{overlapCue}</OverlapCue>
                      ) : null}
                      {formatStockTakeListSupplierLine(item) ? (
                        <StockTakeSuppliers>
                          {formatStockTakeListSupplierLine(item)}
                        </StockTakeSuppliers>
                      ) : null}
                      {normalizeCountType(item) === 'PARTIAL' &&
                      formatPartialCardLine(item, partialGroupNameById) ? (
                        <Tooltip
                          title={partialCardTooltip(item, partialGroupNameById)}
                        >
                          <PartialGroupBadge>
                            {formatPartialCardLine(item, partialGroupNameById)}
                          </PartialGroupBadge>
                        </Tooltip>
                      ) : null}
                      {item?.isLocked ? (
                        <LockStateMeta>Currently locked</LockStateMeta>
                      ) : null}
                    </StyledData>
                    <StyledButtonContainer>
                      <StockPrimaryButton
                        as={Link}
                        to={`/v/${venueId}/stockTakes/${item._id}`}
                        data-testid={`stock-list-open-${item._id}`}
                      >
                        {STOCK_TAKE_LIST_OPEN_LABEL}
                      </StockPrimaryButton>
                      {canRepeatStockTake(item, {
                        venueSupplierIds,
                      }) ? (
                        <Tooltip title='Opens the live count if one is already in progress, or starts a new blank count. Quantities are not copied.'>
                          <CustomButton
                            data-testid={`stock-take-repeat-${item._id}`}
                            disabled={isCreating}
                            onClick={() => handleRepeatStockTake(item)}
                          >
                            <RedoOutlined />
                            Repeat
                          </CustomButton>
                        </Tooltip>
                      ) : null}
                      {renderListReport(item, {
                        label: 'Stock report',
                        reportType: 'valuation-report',
                      })}
                      {renderListReport(item, {
                        label: 'Wastage report',
                        reportType: 'wastage-report',
                      })}
                      <LockButton
                        onClick={() => changeLockStatus(item)}
                        loading={buttonLoading}
                      >
                        {!item.isLocked ? (
                          <>
                            {loadingButton(item, 'LOCK', <LockOutlined />)} Lock
                          </>
                        ) : (
                          <>
                            {loadingButton(item, 'UNLOCK', <UnlockOutlined />)}{' '}
                            Unlock
                          </>
                        )}
                      </LockButton>
                      <CustomButton onClick={() => openAuditModal(item)}>
                        Audit
                      </CustomButton>
                      <CardButton
                        title='Are you sure you want to delete this Stock Take?'
                        placement='topRight'
                        onConfirm={() => handleDeleteButton(item)}
                        onCancel={e => e.stopPropagation()}
                        okText='Yes'
                        cancelText='No'
                      >
                        <CustomButton onClick={e => e.stopPropagation()}>
                          {loadingButton(item, 'DELETE', <DeleteOutlined />)}
                          Delete
                        </CustomButton>
                      </CardButton>
                    </StyledButtonContainer>
                    <TotalsContainer
                      data-testid='stock-list-finance-row'
                      $columns={canViewExpectedAndVariance ? 3 : 2}
                    >
                      {canViewExpectedAndVariance ? (
                        <TotalItem>
                          <TotalLabel>Expected</TotalLabel>
                          <TotalValue
                            data-testid={`stock-list-expected-${item._id}`}
                            data-placeholder={
                              expectedText === STOCK_LIST_EXPECTED_PLACEHOLDER
                                ? 'true'
                                : undefined
                            }
                          >
                            {expectedText}
                          </TotalValue>
                        </TotalItem>
                      ) : null}
                      <TotalItem>
                        <TotalLabel>Stock</TotalLabel>
                        <TotalValue
                          data-testid={`stock-list-stock-${item._id}`}
                          data-placeholder={
                            stockText === STOCK_LIST_NOT_COUNTED_YET
                              ? 'true'
                              : undefined
                          }
                        >
                          {stockText}
                        </TotalValue>
                      </TotalItem>
                      <TotalItem>
                        <TotalLabel>Wastage</TotalLabel>
                        <TotalValue>
                          {formatMoney(item.totalWastageValue)}
                        </TotalValue>
                      </TotalItem>
                    </TotalsContainer>
                  </StyledRow>
                </List.Item>
              )
            }}
          />
          <ManageGroupsModal
            visible={manageGroupsVisible}
            groups={partialGroups}
            products={partialGroupProducts}
            onCancel={() => setManageGroupsVisible(false)}
            onCreateGroup={handleCreateGroup}
            onUpdateGroup={handleUpdateGroup}
            onDeleteGroup={handleDeleteGroup}
            onDuplicateGroup={handleDuplicateGroup}
          />
          <LinkProductsModal
            visible={linkProductsVisible}
            venueId={venueId}
            products={linkableProducts}
            linkedGroups={linkedGroups}
            onCancel={() => setLinkProductsVisible(false)}
            onCreate={handleCreateLinkedProductsProfile}
            onUpdate={handleUpdateLinkedProductsProfile}
            onDelete={handleDeleteLinkedProductsProfile}
            onDuplicate={handleDuplicateLinkedProductsProfile}
          />
        </StockTakesAboveFoldLayout>
      )}
    </div>
  )
}

const StockTakeList = styled(List)`
  && {
    padding-right: ${OLLIE_FAB_INLINE_CLEARANCE}px;
    padding-bottom: ${OLLIE_FAB_CONTENT_CLEARANCE}px;
    box-sizing: border-box;
  }

  .ant-list-item {
    overflow: visible;
  }
`

const StyledRow = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  width: 100%;
  min-width: 0;
  flex-wrap: wrap;
`

const StyledData = styled.div`
  min-width: 220px;
  flex: 1 1 220px;
`

const QuietActions = styled.div`
  margin: ${({ theme }) => theme.spacing.md} 0;

  .ant-collapse {
    background: ${({ theme }) => theme.colours.mayoWhite};
    border: 1px solid ${({ theme }) => theme.colours.panSilver};
    border-radius: 8px;
  }

  .ant-collapse-header {
    color: ${({ theme }) => theme.colours.seaweedGreen} !important;
    font-weight: 600;
  }
`

const QuietActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
`

const FilterBar = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`

const FilterHint = styled.div`
  margin-bottom: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const FilterSubHint = styled.div`
  margin: -6px 0 12px;
  font-size: 11px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const HiddenCountsButton = styled.button`
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
`

const FilterChip = styled.button`
  border: 1px solid
    ${({ isActive, theme }) =>
      isActive ? theme.colours.lettuceGreen : theme.colours.lightGrey};
  background: ${({ isActive, theme }) =>
    isActive ? theme.colours.lettuceGreen : 'white'};
  color: ${({ isActive, theme }) =>
    isActive ? 'white' : theme.colours.otherBlack};
  border-radius: 16px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
`

const StockTakeName = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.colours.otherBlack};
`

const StockTakeDate = styled.div`
  margin-top: 4px;
  font-size: 13px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const StockTakeSuppliers = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const CountTypeBadge = styled.div`
  display: inline-block;
  margin-top: 6px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  background: ${({ isMain, theme }) =>
    isMain ? theme.colours.lettuceGreen : theme.colours.oliveGrey};
  color: white;
`

const PartialGroupBadge = styled.div`
  display: inline-block;
  margin-top: 6px;
  margin-left: 6px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  background: #e8f4ff;
  color: #1f4e79;
`

const OverlapCue = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const LockStateMeta = styled.div`
  margin-top: 6px;
  font-size: 11px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const GroupsWhyLine = styled.p`
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const CountDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 12px;
`

const CountDetailsIntro = styled.div`
  margin-bottom: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #f7fbff;
  border: 1px solid #e8f4ff;
  font-size: 12px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const CountDetailsActions = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
`

const CountDetailsSaved = styled.div`
  padding: 6px 12px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 6px;
  color: #52c41a;
  font-weight: 500;
  font-size: 13px;
`

const CountDetailsSavedHint = styled.div`
  margin-top: 2px;
  font-size: 11px;
  color: #6b6b6b;
  font-weight: 400;
`

const CountDetailsLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const CountDetailsHint = styled.div`
  margin-top: 4px;
  font-size: 11px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const EmailHelperCopy = styled.div`
  margin-top: -4px;
  margin-bottom: 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const EmptyStateBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px 0;
`

const TotalsContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ $columns }) =>
    `repeat(${$columns || 3}, minmax(0, 1fr))`};
  align-items: start;
  column-gap: 16px;
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
`

const TotalItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

const TotalLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.colours.oliveGrey};
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  line-height: 1.2;
`

const TotalValue = styled.span`
  min-height: 1.25em;
  line-height: 1.25em;
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colours.otherBlack};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &[data-placeholder='true'] {
    font-weight: 600;
    color: ${({ theme }) => theme.colours.oliveGrey};
  }
`

const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
  flex-shrink: 0;
`

const HeroCreateForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  margin-top: ${({ theme }) => theme.spacing.sm};
`

const CreatePathGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  ${({ theme }) => theme.device('md')`
    grid-template-columns: 1fr 1fr;
    align-items: stretch;
  `};
`

const CreatePathCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colours.lettuceGreen || '#b5d922'};
  background: ${({ theme }) => theme.colours.mayoWhite || '#fff'};
  opacity: ${({ $inactive }) => ($inactive ? 0.55 : 1)};
`

const CreatePathTitle = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.colours.bbqBlack || '#000'};
`

const CreatePathBody = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const CreatePathWhy = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const CreatePathCta = styled(StockPrimaryButton)`
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
  margin-top: auto;
  min-height: 2.5rem;
  font-size: 0.95rem;
  font-weight: 700;

  &:disabled {
    opacity: 1;
    background: ${({ theme }) => theme.colours.panSilver || '#e0dfdf'};
    border-color: ${({ theme }) => theme.colours.panSilver || '#e0dfdf'};
    color: ${({ theme }) => theme.colours.oliveGrey || '#919191'};
    cursor: not-allowed;
  }
`

const StockHeroJobs = styled.ul`
  margin: 8px 0 0;
  padding: 0 0 0 1.15em;
  font-size: 13px;
  color: ${({ theme }) => theme.colours.oliveGrey};
  line-height: 1.45;
`

const StockHeroJob = styled.li`
  margin: 0 0 2px;
`

const CountSheetShare = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
`

const CreateField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: ${({ $wide }) => ($wide ? '360px' : '180px')};
  flex: ${({ $wide }) => ($wide ? '1 1 360px' : '0 1 auto')};
`

const CreateFieldLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const CreatePeriodRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`

const CustomButton = styled(StockQuietButton)``

const ReportDisabledButton = styled(StockQuietButton)`
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  height: auto;
  padding-top: 0.35rem;
  padding-bottom: 0.35rem;
  white-space: normal;

  &:disabled {
    opacity: 1;
    color: ${({ theme }) => theme.colours.oliveGrey || '#8c8c8c'};
    cursor: default;
  }
`

const LockButton = styled(StockQuietButton)`
  min-width: 90px;
`
const CardButton = styled(Popconfirm)``

const ReviewSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ReviewRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
`

const ReviewTopTitle = styled.div`
  margin-top: 6px;
  font-size: 13px;
  color: #595959;
  font-weight: 700;
`

const ReviewVarianceItem = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  gap: 12px;
`

const ReviewMutedText = styled.div`
  color: #8c8c8c;
  font-size: 13px;
`

const AuditPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const AuditHeaderRow = styled.div`
  font-size: 13px;
`

const AuditSummary = styled.div`
  font-size: 13px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const AuditTopTitle = styled.div`
  margin-top: 4px;
  font-size: 13px;
  font-weight: 700;
  color: #595959;
`

const AuditEvent = styled.div`
  padding: 8px 10px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
`

const AuditReason = styled.div`
  color: #8c8c8c;
`

export default StockList
